const translations = {
  wizardPrevious: { en: "Previous", es: "Anterior", fr: "Précédent", it: "Precedente", de: "Zurück", pt: "Anterior", nl: "Vorige", pl: "Wstecz", ru: "Назад", ar: "السابق", hi: "पिछला", tr: "Önceki", ro: "Anterior", lv: "Iepriekšējais", ch: "上一步", cn: "上一步", my: "Sebelumnya", ms: "Sebelumnya" },
  wizardNext: { en: "Next", es: "Siguiente", fr: "Suivant", it: "Avanti", de: "Weiter", pt: "Seguinte", nl: "Volgende", pl: "Dalej", ru: "Далее", ar: "التالي", hi: "अगला", tr: "Sonraki", ro: "Următorul", lv: "Nākamais", ch: "下一步", cn: "下一步", my: "Seterusnya", ms: "Seterusnya" },
  bookingStepBooking: {
    ar: "الحجز",
    lv: "Rezervācija",
    ro: "Rezervare",
    nl: "Reservering",
    en: "Booking", es: "Reserva", fr: "Réservation", it: "Prenotazione", de: "Reservierung", pl: "Rezerwacja",
    pt: "Reserva", ch: "预订", ru: "Бронирование", my: "Tempahan", hi: "बुकिंग", tr: "Rezervasyon",
    ms: "Tempahan",
  },
  bookingStepContact: {
    ar: "معلومات الاتصال",
    lv: "Kontaktinformācija",
    ro: "Date de contact",
    nl: "Contactgegevens",
    en: "Contact information", es: "Información de contacto", fr: "Coordonnées", it: "Dati di contatto", de: "Kontaktdaten", pl: "Dane kontaktowe",
    pt: "Dados de contacto", ch: "联系信息", ru: "Контактные данные", my: "Maklumat hubungan", hi: "संपर्क जानकारी", tr: "İletişim bilgileri",
    ms: "Maklumat hubungan",
  },
  bookingStepConfirmation: {
    ar: "التأكيد",
    lv: "Apstiprinājums",
    ro: "Confirmare",
    nl: "Bevestiging",
    en: "Confirmation", es: "Confirmación", fr: "Confirmation", it: "Conferma", de: "Bestätigung", pl: "Potwierdzenie",
    pt: "Confirmação", ch: "确认", ru: "Подтверждение", my: "Pengesahan", hi: "पुष्टि", tr: "Onay",
    ms: "Pengesahan",
  },
  days: {
    ar: "أيام",
    lv: "DIENAS",
    ro: "ZILE",
    nl: "DAGEN",
    en: "DAYS",
    es: "DÍAS",
    fr: "JOURS",
    it: "GIORNI",
    de: "TAGE",
    pl: "DNI",
    pt: "DIAS",
    ch: "天",
    ru: "ДНИ",
    my: "HARI",
    hi: "दिन",
    tr: "GÜN",
    ms: "HARI",
  },
  hours: {
    ar: "ساعات",
    lv: "STUNDAS",
    ro: "ORE",
    nl: "UREN",
    en: "HOURS",
    es: "HORAS",
    fr: "HEURES",
    it: "ORE",
    de: "STUNDEN",
    pl: "GODZINY",
    pt: "HORAS",
    ch: "小时",
    ru: "ЧАСЫ",
    my: "JAM",
    hi: "घंटे",
    tr: "SAAT",
    ms: "JAM",
  },
  minutes: {
    ar: "دقائق",
    lv: "MINŪTES",
    ro: "MINUTE",
    nl: "MINUTEN",
    en: "MINUTES",
    es: "MINUTOS",
    fr: "MINUTES",
    it: "MINUTI",
    de: "MINUTEN",
    pl: "MINUTY",
    pt: "MINUTOS",
    ch: "分钟",
    ru: "МИНУТЫ",
    my: "MINIT",
    hi: "मिनट",
    tr: "DAKİKA",
    ms: "MINIT",
  },
  seconds: {
    ar: "ثوانٍ",
    lv: "SEKUNDES",
    ro: "SECUNDE",
    nl: "SECONDEN",
    en: "SECONDS",
    es: "SEGUNDOS",
    fr: "SECONDES",
    it: "SECONDI",
    de: "SEKUNDEN",
    pl: "SEKUNDY",
    pt: "SEGUNDOS",
    ch: "秒",
    ru: "СЕКУНДЫ",
    my: "SAAT",
    hi: "सेकंड",
    tr: "SANİYE",
    ms: "SAAT",
  },
  last_places_available: {
    ar: "آخر الأماكن المتاحة",
    lv: "Pēdējās pieejamās vietas",
    ro: "Ultimele locuri disponibile",
    nl: "Laatste plaatsen beschikbaar",
    en: "Last places available",
    es: "Últimas plazas disponibles",
    fr: "Dernières places disponibles",
    it: "Ultimi posti disponibili",
    de: "Letzte verfügbare Plätze",
    pl: "Ostatnie dostępne miejsca",
    pt: "Últimos lugares disponíveis",
    ch: "最后剩余的位置",
    ru: "Последние доступные места",
    my: "Tempat terakhir yang tersedia",
    hi: "अंतिम उपलब्ध स्थान",
    tr: "Son kalan yerler",
    ms: "Tempat terakhir yang tersedia",
  },
  male: {
    ar: "ذكر",
    lv: "Vīrietis",
    ro: "Masculin",
    nl: "Man",
    en: "Male",
    es: "Masculino",
    fr: "Mâle",
    it: "Maschio",
    de: "Männlich",
    pt: "Macho",
    ch: "男性",
    ru: "мужской",
    my: "lelaki",
    hi: "पुरुष",
    tr: "Erkek",
    pl: "Mężczyzna",
    ms: "lelaki",
  },
  female: {
    ar: "أنثى",
    lv: "Sieviete",
    ro: "Feminin",
    nl: "Vrouw",
    en: "Female",
    es: "Femenino",
    fr: "Femelle",
    it: "Femmina",
    de: "Weiblich",
    pt: "Fêmea",
    ch: "女性",
    ru: "женский",
    my: "perempuan",
    hi: "महिला",
    tr: "Kadın",
    pl: "Kobieta",
    ms: "perempuan",
  },
  other_gender: {
    ar: "آخر",
    lv: "Cits",
    ro: "Altul",
    nl: "Anders",
    en: "Other",
    es: "Otro",
    fr: "Autre",
    it: "Altro",
    de: "Andere",
    pt: "Outro",
    ch: "其他",
    ru: "другой",
    my: "lain",
    hi: "अन्य",
    tr: "Diğer",
    pl: "Inna",
    ms: "lain",
  },
  noAvailabilityToday: {
    ar: "غير متاح اليوم",
    lv: "Šodien nav pieejams",
    ro: "Indisponibil astăzi",
    nl: "Vandaag niet beschikbaar",
    en: "No available today",
    es: "No disponible hoy",
    fr: "Pas disponible aujourd",
    it: "Non disponibile oggi",
    de: "Heute nicht verfügbar",
    pl: "Dzisiaj niedostępny",
    pt: "Não disponível hoje",
    ch: "今天没有空位",
    ru: "Сегодня нет доступных мест",
    my: "Tidak ada ketersediaan hari ini",
    hi: "आज उपलब्ध नहीं है",
    tr: "Bugün uygun değil",
    ms: "Tidak ada ketersediaan hari ini",
  },
  availableAt: {
    ar: "متاح بعد",
    lv: "Pieejams pēc",
    ro: "Disponibil peste",
    nl: "Beschikbaar over",
    en: "Available in",
    es: "Disponible en",
    fr: "Disponible en",
    it: "Disponibile in",
    de: "Verfügbar in",
    pl: "Dostępny w",
    pt: "Disponível em",
    ch: "在",
    ru: "Доступно в",
    my: "Tersedia di",
    hi: "में उपलब्ध",
    tr: "Mevcut",
    ms: "Tersedia di",
  },
  sentMessage: {
    ar: "تم إرسال رسالتك",
    lv: "Jūsu ziņojums ir nosūtīts",
    ro: "Mesajul dumneavoastră a fost trimis",
    nl: "Uw bericht is verzonden",
    en: "Your message has been sent",
    es: "Tu mensaje ha sido enviado",
    fr: "Votre message a été envoyé",
    it: "Il tuo messaggio è stato inviato",
    de: "Ihre Nachricht wurde gesendet",
    pl: "Twoja wiadomość została wysłana",
    pt: "Sua mensagem foi enviada",
    ch: "您的消息已发送",
    ru: "Ваше сообщение было отправлено",
    my: "Mesej anda telah dihantar",
    hi: "आपका संदेश भेज दिया गया है",
    tr: "Mesajınız gönderildi",
    ms: "Mesej anda telah dihantar",
  },
  startDate: {
    ar: "تاريخ البدء",
    lv: "Sākuma datums",
    ro: "Data de început",
    nl: "Startdatum",
    en: "Start date",
    es: "Fecha de inicio",
    fr: "Date de début",
    it: "Data di inizio",
    de: "Startdatum",
    pl: "Data rozpoczęcia",
    pt: "Data de início",
    ch: "开始日期",
    ru: "Дата начала",
    my: "Tarikh mula",
    hi: "प्रारंभ तिथि",
    tr: "Başlangıç tarihi",
    ms: "Tarikh mula",
  },
  endDate: {
    ar: "تاريخ الانتهاء",
    lv: "Beigu datums",
    ro: "Data de sfârșit",
    nl: "Einddatum",
    en: "End date",
    es: "Fecha de fin",
    fr: "Date de fin",
    it: "Data di fine",
    de: "Enddatum",
    pl: "Data zakończenia",
    pt: "Data final",
    ch: "结束日期",
    ru: "Дата окончания",
    my: "Tarikh tamat",
    hi: "अंतिम तिथि",
    tr: "Bitiş tarihi",
    ms: "Tarikh tamat",
  },
  dateRange: {
    ar: "الفترة الزمنية",
    lv: "Datumu diapazons",
    ro: "Interval de date",
    nl: "Datumbereik",
    en: "Date range",
    es: "Rango de fechas",
    fr: "Plage de dates",
    it: "Intervallo di date",
    de: "Datumsbereich",
    pl: "Zakres dat",
    hi: "तिथि सीमा",
    ms: "Julat tarikh",
    tr: "Tarih aralığı",
    pt: "Intervalo de datas",
    ch: "日期范围",
    ru: "Диапазон дат",
    my: "Julat tarikh",
  },
  confirm: {
    ar: "تأكيد",
    lv: "Apstiprināt",
    ro: "Confirmă",
    nl: "Bevestigen",
    en: "Confirm",
    es: "Confirmar",
    fr: "Confirmer",
    it: "Confermare",
    de: "Bestätigen",
    pl: "Potwierdzać",
    hi: "पुष्टि करें",
    ms: "Mengesahkan",
    tr: "Onaylamak",
    pt: "Confirmar",
    ch: "确认",
    ru: "Подтвердить",
    my: "Mengesahkan",
  },
  amount: {
    ar: "المبلغ",
    lv: "Summa",
    ro: "Sumă",
    nl: "Bedrag",
    en: "Amount",
    es: "Cantidad",
    fr: "Montant",
    it: "Quantità",
    de: "Menge",
    pl: "Ilość",
    hi: "मात्रा",
    ms: "Jumlah",
    tr: "Miktar",
    pt: "Quantidade",
    ch: "数量",
    ru: "Количество",
    my: "Jumlah",
  },
  numberOfAttendees: {
    ar: "عدد الحاضرين",
    lv: "Dalībnieku skaits",
    ro: "Număr de participanți",
    nl: "Aantal deelnemers",
    en: "Number of attendees",
    es: "Número de asistentes",
    fr: "Nombre de participants",
    it: "Numero di partecipanti",
    de: "Anzahl der Teilnehmer",
    pl: "Liczba uczestników",
    pt: "Número de participantes",
    ch: "参加人数",
    ru: "Количество гостей",
    my: "Bilangan peserta",
    hi: "उपस्थित लोगों की संख्या",
    ms: "Bilangan peserta",
    tr: "Katılımcı sayısı",
  },
  change: {
    ar: "تغيير",
    lv: "Mainīt",
    ro: "Modifică",
    nl: "Wijzigen",
    en: "Change",
    es: "Cambiar",
    fr: "Modifier",
    it: "Modifica",
    de: "Ändern",
    pl: "Zmień",
    hi: "बदलें",
    ms: "Tukar",
    tr: "Değiştir",
    pt: "Alterar",
    ch: "更改",
    ru: "Изменить",
    my: "Tukar",
  },
  hello: {
    ar: "مرحبًا",
    lv: "Sveiki",
    ro: "Bună",
    nl: "Hallo",
    en: "Hello",
    es: "Hola",
    fr: "Bonjour",
    it: "Ciao",
    de: "Hallo",
    pl: "Cześć",
    pt: "Olá",
    ch: "你好",
    ru: "Здравствуйте",
    my: "Helo",
    hi: "नमस्ते",
    ms: "Helo",
    tr: "Merhaba",
  },
  continue: {
    ar: "متابعة",
    lv: "Turpināt",
    ro: "Continuă",
    nl: "Doorgaan",
    en: "Continue",
    es: "Continuar",
    fr: "Continuer",
    it: "Continua",
    de: "Weiter",
    pl: "Kontynuuj",
    pt: "Continuar",
    hi: "जारी रखें",
    ms: "Teruskan",
    tr: "Devam et",
    ch: "继续",
    ru: "Продолжить",
    my: "Teruskan",
  },
  arrivalTime: {
    ar: "وقت الوصول الدقيق",
    lv: "Precīzs ierašanās laiks",
    ro: "Ora exactă de sosire",
    nl: "Exacte aankomsttijd",
    en: "Exact arrival time",
    es: "Hora exacta de llegada",
    fr: "Heure exacte d’arrivée",
    it: "Orario esatto di arrivo",
    de: "Genaue Ankunftszeit",
    pl: "Dokładna godzina przyjazdu",
    pt: "Hora exata de chegada",
    hi: "आगमन का सही समय",
    ms: "Waktu ketibaan tepat",
    tr: "Kesin varış saati",
    ch: "准确到达时间",
    ru: "Точное время прибытия",
    my: "Waktu ketibaan tepat",
  },
  selectArrivalTime: {
    ar: "اختر وقت وصولك",
    lv: "Izvēlieties ierašanās laiku",
    ro: "Selectați ora de sosire",
    nl: "Selecteer uw aankomsttijd",
    en: "Select your arrival time",
    es: "Selecciona tu hora de llegada",
    fr: "Sélectionnez votre heure d’arrivée",
    it: "Seleziona l’orario di arrivo",
    de: "Ankunftszeit auswählen",
    pl: "Wybierz godzinę przyjazdu",
    pt: "Selecione a hora de chegada",
    hi: "आगमन का समय चुनें",
    ms: "Pilih waktu ketibaan",
    tr: "Varış saatinizi seçin",
    ch: "请选择到达时间",
    ru: "Выберите время прибытия",
    my: "Pilih waktu ketibaan",
  },
  selectedTurn: {
    ar: "الفترة المختارة",
    lv: "Izvēlētais apmeklējuma laiks",
    ro: "Intervalul selectat",
    nl: "Geselecteerde zitting",
    en: "Selected seating",
    es: "Turno seleccionado",
    fr: "Service sélectionné",
    it: "Turno selezionato",
    de: "Ausgewählter Zeitraum",
    pl: "Wybrana tura",
    pt: "Turno selecionado",
    hi: "चयनित समय",
    ms: "Sesi dipilih",
    tr: "Seçilen zaman aralığı",
    ch: "所选时段",
    ru: "Выбранный сеанс",
    my: "Sesi dipilih",
  },
  enterAmount: {
    ar: "أدخل المبلغ",
    lv: "Ievadiet summu",
    ro: "Introduceți suma",
    nl: "Voer een bedrag in",
    en: "Enter amount",
    es: "Introduce cantidad",
    fr: "Entrez le montant",
    it: "Inserisci importo",
    de: "Menge eingeben",
    pl: "Wprowadź ilość",
    hi: "राशि दर्ज करें",
    ms: "Masukkan jumlah",
    tr: "Miktar girin",
    pt: "Introduza a quantidade",
    ch: "请输入数量",
    ru: "Введите количество",
    my: "Masukkan jumlah",
  },
  priceLineLegend: {
    ar: "الوصف",
    lv: "Apraksts",
    ro: "Descriere",
    nl: "Omschrijving",
    en: "Description",
    es: "Leyenda",
    fr: "Description",
    it: "Descrizione",
    de: "Beschreibung",
    pl: "Opis",
    pt: "Descrição",
    ch: "描述",
    ru: "Описание",
    my: "Keterangan",
    ms: "Keterangan",
    hi: "विवरण",
    tr: "Açıklama",
  },
  priceLinePrice: {
    ar: "السعر",
    lv: "Cena",
    ro: "Preț",
    nl: "Prijs",
    en: "Price",
    es: "Precio",
    fr: "Prix",
    it: "Prezzo",
    de: "Preis",
    pl: "Cena",
    pt: "Preço",
    ch: "价格",
    ru: "Цена",
    my: "Harga",
    ms: "Harga",
    hi: "मूल्य",
    tr: "Fiyat",
  },
  addPriceLine: {
    ar: "إضافة بند سعر",
    lv: "Pievienot cenas rindu",
    ro: "Adaugă o linie de preț",
    nl: "Prijsregel toevoegen",
    en: "Add price line",
    es: "Agregar línea de precio",
    fr: "Ajouter une ligne de prix",
    it: "Aggiungi una riga di prezzo",
    de: "Preiszeile hinzufügen",
    pl: "Dodaj pozycję cenową",
    pt: "Adicionar linha de preço",
    ch: "添加价格行",
    ru: "Добавить строку цены",
    my: "Tambah baris harga",
    ms: "Tambah baris harga",
    hi: "मूल्य पंक्ति जोड़ें",
    tr: "Fiyat satırı ekle",
  },
  removePriceLine: {
    ar: "إزالة بند السعر",
    lv: "Noņemt cenas rindu",
    ro: "Șterge linia de preț",
    nl: "Prijsregel verwijderen",
    en: "Remove price line",
    es: "Eliminar línea de precio",
    fr: "Supprimer la ligne de prix",
    it: "Rimuovi la riga di prezzo",
    de: "Preiszeile entfernen",
    pl: "Usuń pozycję cenową",
    pt: "Remover linha de preço",
    ch: "删除价格行",
    ru: "Удалить строку цены",
    my: "Alih keluar baris harga",
    ms: "Alih keluar baris harga",
    hi: "मूल्य पंक्ति हटाएँ",
    tr: "Fiyat satırını kaldır",
  },
  selectTimeRequired: {
    ar: "الوقت مطلوب",
    lv: "Jānorāda laiks",
    ro: "Ora este obligatorie",
    nl: "Tijd is verplicht",
    en: "Time required",
    es: "Tiempo obligatorio",
    fr: "Temps requis",
    it: "Tempo richiesto",
    de: "Erforderliche Zeit",
    pl: "Wymagany czas",
    hi: "आवश्यक समय",
    ms: "Masa diperlukan",
    tr: "Gerekli zaman",
    pt: "Selecione um horário",
    ch: "请选择时间",
    ru: "Выберите время",
    my: "Masa diperlukan",
  },
  totalPrice: {
    ar: "الإجمالي",
    lv: "Kopā",
    ro: "Total",
    nl: "Totaal",
    en: "Total",
    es: "Total",
    fr: "Total",
    it: "Totale",
    de: "Gesamt",
    pl: "Całkowity",
    hi: "कुल",
    ms: "Jumlah keseluruhan",
    tr: "Toplam",
    pt: "Total",
    ch: "总计",
    ru: "Итого",
    my: "Jumlah keseluruhan",
  },
  totalDuration: {
    ar: "المدة الإجمالية",
    lv: "Kopējais ilgums",
    ro: "Durată totală",
    nl: "Totale duur",
    en: "Total duration",
    es: "Duración total",
    fr: "Durée totale",
    it: "Durata totale",
    de: "Gesamtdauer",
    pl: "Całkowity czas trwania",
    hi: "कुल अवधि",
    ms: "Jumlah keseluruhan",
    tr: "Toplam süre",
    pt: "Duração total",
    ch: "总时长",
    ru: "Общая продолжительность",
    my: "Jumlah keseluruhan",
  },
  confirmedBooking: {
    ar: "حجز مؤكد",
    lv: "Apstiprināta rezervācija",
    ro: "Rezervare confirmată",
    nl: "Bevestigde reservering",
    en: "Confirmed booking",
    es: "Reserva confirmada",
    fr: "Réservation confirmée",
    it: "Prenotazione confermata",
    de: "Bestätigte Buchung",
    pl: "Potwierdzona rezerwacja",
    pt: "Reserva confirmada",
    ch: "已确认预订",
    ru: "Подтвержденное бронирование",
    hi: "पुष्टि की गई बुकिंग",
    ms: "Tempahan disahkan",
    tr: "Onaylanmış rezervasyon",
    my: "Tempahan disahkan",
  },
  pendingBooking: {
    ar: "حجز قيد الانتظار",
    lv: "Rezervācija gaida apstiprinājumu",
    ro: "Rezervare în așteptare",
    nl: "Reservering in afwachting",
    en: "Pending booking",
    es: "Reserva pendiente",
    fr: "Réservation en attente",
    it: "Prenotazione in sospeso",
    de: "Ausstehende Buchung",
    pl: "Oczekująca rezerwacja",
    pt: "Reserva pendente",
    ch: "待定预订",
    ru: "Ожидающее бронирование",
    hi: "बुकिंग पेंडिंग",
    ms: "Tempahan tertunda",
    tr: "Bekleyen rezervasyon",
    my: "Tempahan tertunda",
  },
  failedBooking: {
    ar: "فشل الحجز",
    lv: "Rezervācija neizdevās",
    ro: "Rezervare eșuată",
    nl: "Reservering mislukt",
    en: "Failed booking",
    es: "Reserva fallida",
    fr: "Réservation échouée",
    it: "Prenotazione fallita",
    de: "Fehlgeschlagene Buchung",
    pl: "Nieudana rezerwacja",
    pt: "Reserva falhada",
    ch: "预订失败",
    ru: "Неудачное бронирование",
    hi: "बुकिंग विफल",
    ms: "Tempahan gagal",
    tr: "Başarısız rezervasyon",
    my: "Tempahan gagal",
  },
  youHaveScheduledAnEventWith: {
    ar: "لقد حددت موعدًا مع",
    lv: "Jūs esat ieplānojis tikšanos ar",
    ro: "Ați programat un eveniment cu",
    nl: "U heeft een afspraak gepland met",
    en: "You have scheduled an event with",
    es: "Has programado un evento con",
    fr: "Vous avez programmé un événement avec",
    it: "Hai programmato un evento con",
    de: "Sie haben eine Veranstaltung mit",
    pl: "Zaplanowałeś wydarzenie z",
    pt: "Você agendou um evento com",
    ch: "您已安排了一个活动",
    ru: "Вы запланировали мероприятие с",
    my: "Anda telah menjadualkan acara dengan",
    hi: "आपने के साथ एक घटना की योजना बनाई है",
    tr: "Bir etkinlik planladınız",
    ms: "Anda telah menjadualkan acara dengan",
  },
  noAvailableTimeSlots: {
    ar: "لا توجد أوقات متاحة لهذا اليوم",
    lv: "Šajā dienā nav pieejamu laiku",
    ro: "Nu există intervale orare disponibile pentru această zi",
    nl: "Geen beschikbare tijdsloten voor deze dag",
    en: "No available time slots for this day",
    es: "No hay franjas horarias disponibles para este día",
    fr: "Aucune plage horaire disponible pour ce jour",
    it: "Nessuna fascia oraria disponibile per questo giorno",
    de: "Keine verfügbaren Zeitfenster für diesen Tag",
    pl: "Brak dostępnych przedziałów czasowych na ten dzień",
    pt: "Não há horários disponíveis para este dia",
    ch: "当天没有可用的时间段",
    ru: "Нет доступных временных слотов на этот день",
    my: "Tiada slot masa yang tersedia untuk hari ini",
    hi: "इस दिन के लिए कोई उपलब्ध समय स्लॉट नहीं है",
    tr: "Bu gün için uygun zaman dilimi yok",
    ms: "Tiada slot masa yang tersedia untuk hari ini",
  },
  emailValidatingText: {
    ar: "جارٍ التحقق من البريد الإلكتروني...",
    lv: "Notiek e-pasta adreses pārbaude...",
    ro: "Se verifică adresa de e-mail...",
    nl: "E-mailadres wordt gecontroleerd...",
    en: "Validating email...",
    es: "Validando correo electrónico...",
    fr: "Validation de l'e-mail...",
    it: "Convalida dell'e-mail...",
    de: "E-Mail wird überprüft...",
    pl: "Weryfikacja e-maila...",
    pt: "Validando e-mail...",
    ch: "正在验证电子邮件...",
    ru: "Проверка электронной почты...",
    my: "Mengesahkan e-mel...",
    hi: "ईमेल सत्यापित हो रहा है...",
    tr: "E-posta doğrulanıyor...",
    ms: "Mengesahkan e-mel...",
  },
  emailValidationText: {
    ar: "عنوان البريد الإلكتروني هذا غير صالح",
    lv: "Šī e-pasta adrese nav derīga",
    ro: "Această adresă de e-mail nu este validă",
    nl: "Dit e-mailadres is ongeldig",
    en: "Sorry, this email is not valid",
    es: "Lo sentimos, este correo electrónico no es válido",
    fr: "Désolé, cet e-mail n'est pas valide",
    it: "Spiacenti, questa email non è valida",
    de: "Entschuldigung, diese E-Mail ist nicht gültig",
    pl: "Przykro mi, ten e-mail jest nieprawidłowy",
    pt: "Desculpe, este e-mail não é válido",
    ch: "抱歉，此电子邮件无效",
    ru: "Извините, этот адрес электронной почты недействителен",
    my: "Maaf, e-mel ini tidak sah",
    hi: "क्षमा करें, यह ईमेल मान्य नहीं है",
    tr: "Üzgünüm, bu e-posta geçerli değil",
    ms: "Maaf, e-mel ini tidak sah",
  },
  fileValidationText: {
    ar: "هذا الملف غير صالح",
    lv: "Šis fails nav derīgs",
    ro: "Acest fișier nu este valid",
    nl: "Dit bestand is ongeldig",
    en: "Sorry, this file is not valid",
    es: "Lo sentimos, este archivo no es válido",
    fr: "Désolé, ce fichier n'est pas valide",
    it: "Spiacenti, questo file non è valido",
    de: "Entschuldigung, diese Datei ist nicht gültig",
    pl: "Przykro mi, ten plik jest nieprawidłowy",
    pt: "Desculpe, este arquivo não é válido",
    ch: "抱歉，此文件无效",
    ru: "Извините, этот файл недействителен",
    my: "Maaf, fail ini tidak sah",
    hi: "क्षमा करें, यह फ़ाइल मान्य नहीं है",
    tr: "Üzgünüm, bu dosya geçerli değil",
    ms: "Maaf, fail ini tidak sah",
  },
  zipcodeValidationText: {
    ar: "هذا الرمز البريدي غير صالح",
    lv: "Šis pasta indekss nav derīgs",
    ro: "Acest cod poștal nu este valid",
    nl: "Deze postcode is ongeldig",
    en: "Sorry, this zip code is not valid",
    es: "Lo sentimos, este código postal no es válido",
    fr: "Désolé, ce code postal n'est pas valide",
    it: "Spiacenti, questo codice postale non è valido",
    de: "Entschuldigung, diese Postleitzahl ist nicht gültig",
    pl: "Przykro mi, ten kod pocztowy jest nieprawidłowy",
    pt: "Desculpe, este código postal não é válido",
    ch: "抱歉，此邮政编码无效",
    ru: "Извините, этот почтовый индекс недействителен",
    my: "Maaf, poskod ini tidak sah",
    hi: "क्षमा करें, यह ज़िप कोड मान्य नहीं है",
    tr: "Üzgünüm, bu posta kodu geçerli değil",
    ms: "Maaf, poskod ini tidak sah",
  },
  telValidationText: {
    ar: "رقم الهاتف هذا غير صالح",
    lv: "Šis tālruņa numurs nav derīgs",
    ro: "Acest număr de telefon nu este valid",
    nl: "Dit telefoonnummer is ongeldig",
    en: "Sorry, this phone number is not valid",
    es: "Lo sentimos, este número de teléfono no es válido",
    fr: "Désolé, ce numéro de téléphone n'est pas valide",
    it: "Spiacenti, questo numero di telefono non è valido",
    de: "Entschuldigung, diese Telefonnummer ist nicht gültig",
    pl: "Przykro mi, ten numer telefonu jest nieprawidłowy",
    pt: "Desculpe, este número de telefone não é válido",
    ch: "抱歉，此电话号码无效",
    ru: "Извините, этот номер телефона недействителен",
    my: "Maaf, nombor telefon ini tidak sah",
    hi: "क्षमा करें, यह फोन नंबर मान्य नहीं है",
    tr: "Üzgünüm, bu telefon numarası geçerli değil",
    ms: "Maaf, nombor telefon ini tidak sah",
  },
  urlValidationText: {
    ar: "يرجى استخدام رابط يبدأ بـ https:// أو http://.",
    lv: "Lūdzu, izmantojiet URL ar https:// vai http://.",
    ro: "Utilizați un URL cu https:// sau http://.",
    nl: "Gebruik een URL met https:// of http://.",
    en: "Please use a https:// or http:// URL.",
    es: "Utiliza una URL de https:// o http://.",
    fr: "Veuillez utiliser une URL https:// ou http://.",
    it: "Utilizza un URL di https:// o http://.",
    de: "Bitte verwenden Sie eine https:// oder http:// URL.",
    pl: "Użyj adresu URL https:// lub http://.",
    pt: "Use uma URL https:// ou http://.",
    ch: "请使用 https:// 或 http:// URL。",
    ru: "Пожалуйста, используйте URL-адрес https:// или http://.",
    my: "Sila gunakan URL https:// atau http://.",
    hi: "कृपया एक https:// या http:// यूआरएल का उपयोग करें।",
    tr: "Lütfen bir https:// veya http:// URL'si kullanın.",
    ms: "Sila gunakan URL https:// atau http://.",
  },
  numberValidationText: {
    ar: "هذه ليست قيمة رقمية",
    lv: "Tas nav skaitlis",
    ro: "Aceasta nu este o valoare numerică",
    nl: "Dit is geen getal",
    en: "This is not a number",
    es: "Este no es un número",
    fr: "Ce n'est pas un nombre",
    it: "Questo non è un numero",
    de: "Das ist keine Zahl",
    pl: "To nie jest liczba",
    pt: "Isto não é um número",
    ch: "这不是一个数字",
    ru: "Это не число",
    my: "Ini bukan nombor",
    hi: "यह एक संख्या नहीं है",
    tr: "Bu bir sayı değil",
    ms: "Ini bukan nombor",
  },
  regularExpressionValidationText: {
    ar: "هذا الحقل غير صالح",
    lv: "Šis lauks nav derīgs",
    ro: "Acest câmp nu este valid",
    nl: "Dit veld is ongeldig",
    en: "This field is not valid",
    es: "Este campo no es válido",
    fr: "Ce champ n'est pas valide",
    it: "Questo campo non è valido",
    de: "Dieses Feld ist ungültig",
    pl: "To pole jest nieprawidłowe",
    pt: "Este campo não é válido",
    ch: "此字段无效",
    ru: "Это поле недействительно",
    my: "Medan ini tidak sah",
    hi: "यह फ़ील्ड मान्य नहीं है",
    tr: "Bu alan geçerli değil",
    ms: "Medan ini tidak sah",
  },
  requiredValidationText: {
    ar: "هذا الحقل مطلوب",
    lv: "Šis lauks ir obligāts",
    ro: "Acest câmp este obligatoriu",
    nl: "Dit veld is verplicht",
    en: "This field is required",
    es: "Este campo es obligatorio",
    fr: "Ce champ est requis",
    it: "Questo campo è obbligatorio",
    de: "Dieses Feld ist erforderlich",
    pl: "To pole jest wymagane",
    pt: "Este campo é obrigatório",
    ch: "此字段为必填项",
    ru: "Это поле обязательно для заполнения",
    my: "Medan ini diperlukan",
    hi: "यह फ़ील्ड आवश्यक है",
    tr: "Bu alan gereklidir",
    ms: "Medan ini diperlukan",
  },
  maxNumberValidationText: {
    ar: "القيمة القصوى هي {max}",
    lv: "Maksimālā vērtība ir {max}",
    ro: "Valoarea maximă este {max}",
    nl: "De maximale waarde is {max}",
    en: "The max value is {max}",
    es: "El valor máximo es {max}",
    fr: "La valeur maximale est {max}",
    it: "Il valore massimo è {max}",
    de: "Der Maximalwert ist {max}",
    pl: "Maksymalna wartość to {max}",
    pt: "O valor máximo é {max}",
    ch: "最大值为 {max}",
    ru: "Максимальное значение {max}",
    my: "Nilai maksimum ialah {max}",
    hi: "अधिकतम मान {max} है",
    tr: "Maks değer {max}",
    ms: "Nilai maksimum ialah {max}",
  },
  minNumberValidationText: {
    ar: "القيمة الدنيا هي {min}",
    lv: "Minimālā vērtība ir {min}",
    ro: "Valoarea minimă este {min}",
    nl: "De minimale waarde is {min}",
    en: "The min value is {min}",
    es: "El valor mínimo es {min}",
    fr: "La valeur minimale est {min}",
    it: "Il valore minimo è {min}",
    de: "Der Minimalwert ist {min}",
    pl: "Minimalna wartość to {min}",
    pt: "O valor mínimo é {min}",
    ch: "最小值为 {min}",
    ru: "Минимальное значение {min}",
    my: "Nilai minimum ialah {min}",
    hi: "न्यूनतम मान {min} है",
    tr: "Minimum değer {min}",
    ms: "Nilai minimum ialah {min}",
  },
  maxAmountValidationText: {
    ar: "المبلغ الأقصى هو {max}",
    lv: "Maksimālā summa ir {max}",
    ro: "Suma maximă este {max}",
    nl: "Het maximale bedrag is {max}",
    en: "The max amount is {max}",
    es: "La cantidad máxima es {max}",
    fr: "Le montant maximum est {max}",
    it: "L'importo massimo è {max}",
    de: "Der Maximalbetrag beträgt {max}",
    pl: "Maksymalna kwota to {max}",
    pt: "O valor máximo é {max}",
    ch: "最大金额为 {max}",
    ru: "Максимальная сумма {max}",
    my: "Jumlah maksimum ialah {max}",
    hi: "अधिकतम राशि {max} है",
    tr: "Maksimum miktar {max}",
    ms: "Jumlah maksimum ialah {max}",
  },
  minAmountValidationText: {
    ar: "المبلغ الأدنى هو {min}",
    lv: "Minimālā summa ir {min}",
    ro: "Suma minimă este {min}",
    nl: "Het minimale bedrag is {min}",
    en: "The min amount is {min}",
    es: "La cantidad mínima es {min}",
    fr: "Le montant minimum est {min}",
    it: "L'importo minimo è {min}",
    de: "Der Mindestbetrag beträgt {min}",
    pl: "Minimalna kwota to {min}",
    pt: "O valor mínimo é {min}",
    ch: "最小金额为 {min}",
    ru: "Минимальная сумма {min}",
    my: "Jumlah minimum ialah {min}",
    hi: "न्यूनतम राशि {min} है",
    tr: "Minimum miktar {min}",
    ms: "Jumlah minimum ialah {min}",
  },
  bookingCategoryRequiredValidationText: {
    ar: "فئة الحجز مطلوبة",
    lv: "Jānorāda rezervācijas kategorija",
    ro: "Categoria rezervării este obligatorie",
    nl: "Een reserveringscategorie is verplicht",
    en: "Booking category is required",
    es: "Se requiere categoría de reserva",
    fr: "La catégorie de réservation est requise",
    it: "La categoria di prenotazione è obbligatoria",
    de: "Buchungskategorie ist erforderlich",
    pl: "Kategoria rezerwacji jest wymagana",
    pt: "A categoria de reserva é obrigatória",
    ch: "预订类别是必需的",
    ru: "Требуется категория бронирования",
    my: "Kategori tempahan diperlukan",
    hi: "बुकिंग श्रेणी आवश्यक है",
    tr: "Rezervasyon kategorisi gereklidir",
    ms: "Kategori tempahan diperlukan",
  },
  maxDurationValidationText: {
    ar: "المدة القصوى هي {max} أيام",
    lv: "Maksimālais ilgums ir {max} dienas",
    ro: "Durata maximă este de {max} zile",
    nl: "De maximale duur is {max} dagen",
    en: "The max duration is {max} days",
    es: "La duración máxima es de {max} días",
    fr: "La durée maximale est de {max} jours",
    it: "La durata massima è di {max} giorni",
    de: "Die maximale Dauer beträgt {max} Tage",
    pl: "Maksymalny czas trwania to {max} dni",
    pt: "A duração máxima é de {max} dias",
    ch: "最大持续时间为 {max} 天",
    ru: "Максимальная продолжительность {max} дней",
    my: "Tempoh maksimum ialah {max} hari",
    hi: "अधिकतम अवधि {max} दिन है",
    tr: "Maksimum süre {max} gündür",
    ms: "Tempoh maksimum ialah {max} hari",
  },
  minDurationValidationText: {
    ar: "المدة الدنيا هي {min} أيام",
    lv: "Minimālais ilgums ir {min} dienas",
    ro: "Durata minimă este de {min} zile",
    nl: "De minimale duur is {min} dagen",
    en: "The min duration is {min} days",
    es: "La duración mínima es de {min} días",
    fr: "La durée minimale est de {min} jours",
    it: "La durata minima è di {min} giorni",
    de: "Die Mindestdauer beträgt {min} Tage",
    pl: "Minimalny czas trwania to {min} dni",
    pt: "A duração mínima é de {min} dias",
    ch: "最小持续时间为 {min} 天",
    ru: "Минимальная продолжительность {min} дней",
    my: "Tempoh minimum ialah {min} hari",
    hi: "न्यूनतम अवधि {min} दिन है",
    tr: "Minimum süre {min} gündür",
    ms: "Tempoh minimum ialah {min} hari",
  },
  bookingDateRangeRequiredValidationText: {
    ar: "الفترة الزمنية للحجز مطلوبة",
    lv: "Jānorāda rezervācijas datumu diapazons",
    ro: "Intervalul de date al rezervării este obligatoriu",
    nl: "Een datumbereik voor de reservering is verplicht",
    en: "Booking date range is required",
    es: "El rango de fechas de reserva es obligatorio",
    fr: "La plage de dates de réservation est requise",
    it: "L'intervallo di date di prenotazione è obbligatorio",
    de: "Der Buchungszeitraum ist erforderlich",
    pl: "Zakres dat rezerwacji jest wymagany",
    pt: "O intervalo de datas da reserva é obrigatório",
    ch: "预订日期范围是必需的",
    ru: "Требуется диапазон дат бронирования",
    my: "Julat tarikh tempahan diperlukan",
    hi: "बुकिंग तिथि सीमा आवश्यक है",
    tr: "Rezervasyon tarih aralığı gereklidir",
    ms: "Julat tarikh tempahan diperlukan",
  },
  bookingDateRequiredValidationText: {
    ar: "تاريخ الحجز مطلوب",
    lv: "Jānorāda rezervācijas datums",
    ro: "Data rezervării este obligatorie",
    nl: "Een reserveringsdatum is verplicht",
    en: "Booking date is required",
    es: "Se requiere fecha de reserva",
    fr: "La date de réservation est requise",
    it: "La data di prenotazione è obbligatoria",
    de: "Das Buchungsdatum ist erforderlich",
    pl: "Data rezerwacji jest wymagana",
    pt: "A data da reserva é obrigatória",
    ch: "预订日期是必需的",
    ru: "Требуется дата бронирования",
    my: "Tarikh tempahan diperlukan",
    hi: "बुकिंग तिथि आवश्यक है",
    tr: "Rezervasyon tarihi gereklidir",
    ms: "Tarikh tempahan diperlukan",
  },
  dateBeforeTodayValidationText: {
    ar: "يجب أن يكون التاريخ بعد اليوم",
    lv: "Datumam jābūt pēc šodienas",
    ro: "Data trebuie să fie după ziua de astăzi",
    nl: "De datum moet na vandaag liggen",
    en: "The date must be after today",
    es: "La fecha debe ser posterior a hoy",
    fr: "La date doit être postérieure à aujourd'hui",
    it: "La data deve essere successiva a oggi",
    de: "Das Datum muss nach heute liegen",
    pl: "Data musi być po dzisiejszym dniu",
    pt: "A data deve ser posterior a hoje",
    ch: "日期必须在今天之后",
    ru: "Дата должна быть позже сегодняшнего дня",
    my: "Tarikh mesti selepas hari ini",
    hi: "तारीख आज के बाद होनी चाहिए",
    tr: "Tarih bugünden sonra olmalıdır",
    ms: "Tarikh mesti selepas hari ini",
  },
  dropOffBeforePickUpValidationText: {
    ar: "يجب أن يكون تاريخ الاستلام بعد تاريخ التسليم.",
    lv: "Saņemšanas datumam jābūt pēc nodošanas datuma.",
    ro: "Data preluării trebuie să fie după data predării.",
    nl: "De ophaaldatum moet na de afleverdatum liggen.",
    en: "The pick-up date must be after the drop-off date.",
    es: "La fecha de recogida debe ser posterior a la fecha de entrega.",
    fr: "La date de prise en charge doit être postérieure à la date de dépôt.",
    it: "La data di ritiro deve essere successiva alla data di consegna.",
    de: "Das Abholdatum muss nach dem Abgabedatum liegen.",
    pl: "Data odbioru musi być po dacie zwrotu.",
    pt: "A data de recolha deve ser posterior à data de entrega.",
    ch: "取件日期必须在交付日期之后。",
    ru: "Дата получения должна быть позже даты возврата.",
    my: "Tarikh pengambilan mesti selepas tarikh penghantaran.",
    hi: "पिक-अप तिथि ड्रॉप-ऑफ तिथि के बाद होनी चाहिए।",
    tr: "Alım tarihi, teslimat tarihinden sonra olmalıdır.",
    ms: "Tarikh pengambilan mesti selepas tarikh penghantaran.",
  },
  pickUpBeforeDropOffValidationText: {
    ar: "يجب أن يكون تاريخ التسليم قبل تاريخ الاستلام.",
    lv: "Nodošanas datumam jābūt pirms saņemšanas datuma.",
    ro: "Data predării trebuie să fie înainte de data preluării.",
    nl: "De afleverdatum moet vóór de ophaaldatum liggen.",
    en: "The drop-off date must be before the pick-up date.",
    es: "La fecha de entrega debe ser anterior a la fecha de recogida.",
    fr: "La date de dépôt doit être antérieure à la date de prise en charge.",
    it: "La data di consegna deve essere precedente alla data di ritiro.",
    de: "Das Abgabedatum muss vor dem Abholdatum liegen.",
    pl: "Data zwrotu musi być przed datą odbioru.",
    pt: "A data de entrega deve ser anterior à data de recolha.",
    ch: "交付日期必须在取件日期之前。",
    ru: "Дата возврата должна быть раньше даты получения.",
    my: "Tarikh penghantaran mesti sebelum tarikh pengambilan.",
    hi: "ड्रॉप-ऑफ तिथि पिक-अप तिथि से पहले होनी चाहिए।",
    tr: "Teslimat tarihi, alım tarihinden önce olmalıdır.",
    ms: "Tarikh penghantaran mesti sebelum tarikh pengambilan.",
  },
  termsViewDocumentNotice: {
    ar: "يرجى فتح المستند قبل المتابعة.",
    lv: "Pirms turpināt, lūdzu, atveriet dokumentu.",
    ro: "Deschideți documentul înainte de a continua.",
    nl: "Open het document voordat u doorgaat.",
    en: "Please open the document before continuing.",
    es: "Por favor, abre el documento antes de continuar.",
    fr: "Veuillez ouvrir le document avant de continuer.",
    it: "Si prega di aprire il documento prima di continuare.",
    de: "Bitte öffnen Sie das Dokument, bevor Sie fortfahren.",
    pl: "Otwórz dokument przed kontynuowaniem.",
    pt: "Por favor, abra o documento antes de continuar.",
    ch: "请在继续之前打开文档。",
    ru: "Пожалуйста, откройте документ перед продолжением.",
    my: "Sila buka dokumen sebelum meneruskan.",
    hi: "कृपया जारी रखने से पहले दस्तावेज़ खोलें।",
    tr: "Devam etmeden önce lütfen belgeyi açın.",
    ms: "Sila buka dokumen sebelum meneruskan.",
  },
  termsViewDocumentLink: {
    ar: "عرض / تنزيل المستند",
    lv: "Skatīt / lejupielādēt dokumentu",
    ro: "Vezi / descarcă documentul",
    nl: "Document bekijken / downloaden",
    en: "View / download document",
    es: "Ver / descargar documento",
    fr: "Voir / télécharger le document",
    it: "Visualizza / scarica documento",
    de: "Dokument anzeigen / herunterladen",
    pl: "Wyświetl / pobierz dokument",
    pt: "Ver / descarregar documento",
    ch: "查看 / 下载文档",
    ru: "Просмотреть / скачать документ",
    my: "Lihat / muat turun dokumen",
    hi: "दस्तावेज़ देखें / डाउनलोड करें",
    tr: "Belgeyi görüntüle / indir",
    ms: "Lihat / muat turun dokumen",
  },
  termsAcceptButton: {
    ar: "قبول الشروط",
    lv: "Pieņemt noteikumus",
    ro: "Acceptă termenii",
    nl: "Voorwaarden accepteren",
    en: "Accept terms",
    es: "Aceptar términos",
    fr: "Accepter les conditions",
    it: "Accetta i termini",
    de: "Bedingungen akzeptieren",
    pl: "Zaakceptuj warunki",
    pt: "Aceitar termos",
    ch: "接受条款",
    ru: "Принять условия",
    my: "Terima syarat",
    hi: "शर्तें स्वीकार करें",
    tr: "Şartları kabul et",
    ms: "Terima syarat",
  }, 
  reSendEmail: {
    ar: "إرسال بريد إلكتروني إلى العميل المحتمل",
    lv: "Sūtīt e-pastu potenciālajam klientam",
    ro: "Trimite e-mail potențialului client",
    nl: "E-mail naar de lead sturen",
    en: "Send email to the lead",
    es: "Enviar email al lead",
    fr: "Envoyer un e-mail au prospect",
    it: "Invia un'e-mail al lead",
    de: "E-Mail an den Lead senden",
    pl: "Wyślij e-mail do potencjalnego klienta",
    pt: "Enviar e-mail ao lead",
    ch: "向潜在客户发送电子邮件",
    ru: "Отправить письмо потенциальному клиенту",
    my: "Hantar e-mel kepada prospek",
    hi: "लीड को ईमेल भेजें",
    tr: "Potansiyel müşteriye e-posta gönder",
    ms: "Hantar e-mel kepada prospek",
  },
  reSendWhatsapp: {
    ar: "إرسال رسالة واتساب إلى العميل المحتمل",
    lv: "Sūtīt WhatsApp ziņu potenciālajam klientam",
    ro: "Trimite mesaj WhatsApp potențialului client",
    nl: "WhatsApp naar de lead sturen",
    en: "Send WhatsApp to the lead",
    es: "Enviar WhatsApp al lead",
    fr: "Envoyer un WhatsApp au prospect",
    it: "Invia un WhatsApp al lead",
    de: "WhatsApp an den Lead senden",
    pl: "Wyślij WhatsApp do potencjalnego klienta",
    pt: "Enviar WhatsApp ao lead",
    ch: "向潜在客户发送 WhatsApp",
    ru: "Отправить WhatsApp потенциальному клиенту",
    my: "Hantar WhatsApp kepada prospek",
    hi: "लीड को WhatsApp भेजें",
    tr: "Potansiyel müşteriye WhatsApp gönder",
    ms: "Hantar WhatsApp kepada prospek",
  },
  termsAcceptedLabel: {
    ar: "تم قبول الشروط",
    lv: "Noteikumi pieņemti",
    ro: "Termeni acceptați",
    nl: "Voorwaarden geaccepteerd",
    en: "Terms accepted",
    es: "Términos aceptados",
    fr: "Conditions acceptées",
    it: "Termini accettati",
    de: "Bedingungen akzeptiert",
    pl: "Warunki zaakceptowane",
    pt: "Termos aceites",
    ch: "条款已接受",
    ru: "Условия приняты",
    my: "Syarat diterima",
    hi: "शर्तें स्वीकृत",
    tr: "Şartlar kabul edildi",
    ms: "Syarat diterima",
  },
  aiHumanHandoffButton: {
    ar: "التحدث مع شخص",
    lv: "Runāt ar cilvēku",
    ro: "Vorbește cu o persoană",
    nl: "Met een medewerker praten",
    en: "Talk to a person",
    es: "Hablar con una persona",
    fr: "Parler à une personne",
    it: "Parlare con una persona",
    de: "Mit einer Person sprechen",
    pl: "Porozmawiaj z człowiekiem",
    pt: "Falar com uma pessoa",
    ch: "与真人交谈",
    ru: "Поговорить с человеком",
    my: "Bercakap dengan seseorang",
    hi: "किसी व्यक्ति से बात करें",
    tr: "Bir kişiyle konuş",
    ms: "Bercakap dengan seseorang",
  }
}

export default translations;
